export const FormField = {
  email: 'email',
  companyType: 'companyType',
} as const;
